var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14776_9484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 5.33398H5.3387M1.33203 3.46732L1.33203 6.45033C1.33203 6.77645 1.33203 6.93951 1.36887 7.09296C1.40153 7.22901 1.45541 7.35907 1.52851 7.47836C1.61097 7.61292 1.72627 7.72822 1.95687 7.95882L7.06929 13.0712C7.86132 13.8633 8.25734 14.2593 8.714 14.4077C9.11568 14.5382 9.54838 14.5382 9.95006 14.4077C10.4067 14.2593 10.8027 13.8633 11.5948 13.0712L13.0693 11.5967C13.8613 10.8047 14.2573 10.4087 14.4057 9.95202C14.5362 9.55033 14.5362 9.11764 14.4057 8.71595C14.2573 8.25929 13.8613 7.86328 13.0693 7.07124L7.95687 1.95882C7.72627 1.72822 7.61097 1.61292 7.47641 1.53046C7.35711 1.45736 7.22705 1.40349 7.09101 1.37082C6.93756 1.33398 6.7745 1.33398 6.44837 1.33398L3.46536 1.33398C2.71863 1.33398 2.34526 1.33398 2.06004 1.47931C1.80916 1.60714 1.60519 1.81111 1.47736 2.062C1.33203 2.34721 1.33203 2.72058 1.33203 3.46732ZM5.66537 5.33398C5.66537 5.51808 5.51613 5.66732 5.33203 5.66732C5.14794 5.66732 4.9987 5.51808 4.9987 5.33398C4.9987 5.14989 5.14794 5.00065 5.33203 5.00065C5.51613 5.00065 5.66537 5.14989 5.66537 5.33398Z",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14776_9484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.a67090f13c19ce85e125534b6634c6e3.svg";
export { ForwardRef as ReactComponent };